import { gql } from "@apollo/client";

export const SETTIMER = gql`
  mutation saveTimer($book_id: ID!, $audio_time: Int, $is_author: Boolean) {
    setTimer(book_id: $book_id, audio_time: $audio_time, is_author: $is_author)
  }
`;

export const SAVEBOOKMARK = gql`
  mutation saveBookmark($book_id: ID!, $chapter: Int!, $is_author: Boolean) {
    saveBookmark(book_id: $book_id, chapter: $chapter, is_author: $is_author)
  }
`;

export const SAVERESPONSE = gql`
  mutation saveResponse(
    $question_id: ID!
    $response: ID!
    $correct: Boolean!
    $is_creator: Boolean
  ) {
    saveQuestionResponse(
      question_id: $question_id
      response: $response
      correct: $correct
      is_creator: $is_creator
    )
  }
`;

export const GETREADER = gql`
  query getReader($book_id: ID!, $class_id: ID, $reader_type: String) {
    book(id: $book_id, class_id: $class_id, reader_type: $reader_type) {
      id
      chapters
      title
      url
      total_ratings
      coming_soon
      print_url
      level_id
      rank
      rating
      rating_teachers
      rating_students
      score
      image_ver
      has_prereading
      has_glossary
      has_introduction
      has_aboutstory
      has_cultural
      glossary
      read_time
      total_words
      unique_words
      tense
      images {
        cover
        thumb
        poster
      }
      level {
        id
        name
      }
      description_short
      release_date
      language {
        id
        name
      }
      categories {
        id
        name
      }
      nav_colors {
        background
        color
      }
    }
    affirmations(type: correct) {
      id
      message
      type
    }
  }
`;

export const GET_QUESTIONS = gql`
  query getQuestions($book_id: ID!, $chapter: String!, $is_creator: Boolean) {
    bookQuestions(
      book_id: $book_id
      chapter: $chapter
      random: true
      is_creator: $is_creator
    ) {
      id
      chapter
      question
      success_meme
      success_msg
      fail_msg
      fail_meme
      response
      correct
      updated
      timestamp
      tries
      options {
        id
        question_id
        option_txt
        accepted
      }
    }
    retakeChapter(book_id: $book_id, chapters: [$chapter]) {
      requested
      created_at
    }
  }
`;
export const GET_AFFIRMATIONS = gql`
  query {
    affirmations {
      id
      message
      type
    }
  }
`;

export const ALLOW_TEACHER_RETAKE = gql`
  mutation allowTeacherRetake(
    $book_id: ID!
    $page: String
    $is_creator: Boolean
  ) {
    allowTeacherRetake(book_id: $book_id, page: $page, is_creator: $is_creator)
  }
`;
